<section class="stc-legales banner-padding">
    <div class="container">
        <div class="row sub-headers-inside">
             <div class="col-12 text-center my-auto">
                <div class="overlap-signature header-inside">
                    <span class="letter"> <span class="signature-text">Reglamento</span></span>
                    <h2 class="main-text">Becario</h2>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="stc-legal reglamento-becario">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="container-legal" data-aos="fade-up" data-aos-easing="ease" data-aos-duration="3000">

                    <div class="docx-wrapper" [innerHTML]="htmlContent"></div>

                </div>
            </div>
        </div>
    </div>
</section>